module.exports = __webpack_public_path__ + "static/media/Ø2_2.02b32575.png";